import Divider from '../Divider';

const ShowreelSection = ({title, videoUrl = 'https://storage.googleapis.com/lesia-k/videos/Showreel720.mp4'}: {title?: string, videoUrl?: string}) => {
    return <section className="max-h-screen w-screen relative">
        <video
            className="absolute top-0 left-0 w-full h-full object-cover opacity-5 invert"
            autoPlay
            muted
            loop
            playsInline
        >
            <source src={videoUrl} type="video/mp4"/>
            {/* fallback для браузеров, не поддерживающих видео */}
            Your browser does not support the video tag.
        </video>

        {title && (<Divider />)}
        {title && (
            <div className="flex justify-center items-center ">
                <h1 className="text-6xl md:p-24 p-12 font-bold text-center max-w-6xl font-boldonse text-transparent bg-clip-text bg-gradient-to-l from-pink-200 to-pink-400 drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)]">{title || '2025'}</h1>
            </div>
        )}
        <div className="flex w-full relative pb-20">
            <div className="lg:w-full w-screen p-2 max-h-1/2">
                <video className="m-auto lg:max-w-screen-lg  object-cover rounded-lg shadow-gray-900 shadow-2xl"
                       autoPlay
                       muted
                       loop
                       playsInline
                       controls
                       poster="https://storage.googleapis.com/lesia-k/Pictures/CatFish.png"
                >
                    <source src={videoUrl} type="video/mp4"/>
                    {/* fallback для браузеров, не поддерживающих видео */}
                    Your browser does not support the video tag.
                </video>
            </div>
        </div>
    </section>
}

export default ShowreelSection;
